<template>
  <v-text-field :label="label" v-model="dateValue" type="text" :rules="validationRules" :disabled="disabled" filled />
</template>

<script>
import fieldMixin from '@/mixins/LeanField';
import dayjs from 'dayjs';

export default {
  name: 'LeanDate',
  mixins: [fieldMixin],
  props: {
    type: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dateValue: ''
    };
  },
  mounted() {
    let currentDate = this.resolved;
    if (!this.resolved && this.config?.default) {
      currentDate = this.getDefaultDateTime();
    }
    const dateObject = dayjs(currentDate);
    if (this.config?.timezone) {
      dateObject.tz(defaultTimezone);
    }
    this.dateValue = dateObject.isValid()
      ? dateObject.format(this.config?.format || 'YYYY-MM-DD hh:mm:ss')
      : '';
  },
  methods: {
    getDefaultDateTime() {
      let defaultDate = new Date(Date.now());
      // TODO: need a extension to handle config.default.source"
      return defaultDate;
    }
  },
  watch: {
    dateValue(val) {
      // dayjs.extend(customParseFormat)
      try {
        this.value = dayjs(val, [this.config.format, 'YYYY-MM-DD hh:mm:ss'])?.toISOString();
      } catch (error) {
        console.error(error);
      }
    }
  }
};
</script>
